<h2 mat-dialog-title class="dialog-title">
	{{ (data.title || "button.edit") | translate }}
</h2>

<mat-dialog-content class="dialog-content">
	<form [formGroup]="form">
		<div class="form-row mb-0 my-2">
			<!-- Start Date -->
			<div class="m-form col-md-6 col-12 form-group mb-3">
				<label>{{ "menu.care_ben.st_date" | translate }}</label>
				<app-date-picker-locale formControlName="start_date"></app-date-picker-locale>
			</div>

			<!-- End Date -->
			<div class="m-form col-md-6 col-12 form-group mb-3">
				<label>{{ "menu.care_ben.en_date" | translate }}</label>
				<app-date-picker-locale formControlName="end_date"></app-date-picker-locale>
			</div>

			<!-- Hospital Type -->
			<div [class]="form.controls['is_contract_hospital'].value !== null ? 'm-form col-md-4 col-12 form-group mb-3' : 'm-form col-md-12 col-12 form-group mb-3'">
				<label class="required">{{ "request.hospital_type" | translate }}</label>
				<app-select formControlName="is_contract_hospital" (selectChange)="onContractTypeChange($event)">
					<app-option *ngIf="showContractTypeNull" [value]="null">
						{{ "status.no" | translate }}
					</app-option>
					<app-option *ngIf="showContractTypeAll" [value]="'ALL'">
						{{ "status.all" | translate }}
					</app-option>
					<app-option *ngIf="showContractTypePartner" [value]="HOSPITAL_CONTRACT_TYPE.PARTNER">
						{{ "request.contracted" | translate }}
					</app-option>
					<app-option *ngIf="showContractTypeNonPartner" [value]="HOSPITAL_CONTRACT_TYPE.NON_PARTNER">
						{{ "request.not_contracted" | translate }}
					</app-option>
				</app-select>
			</div>

			<!-- Hospital -->
			<div class="m-form col-md-8 col-12 form-group mb-3" *ngIf="form.controls['is_contract_hospital'].value !== null">
				<label class="required">{{ "maternity.hospital" | translate }}</label>
				<app-select formControlName="hospital" [enableSearch]="true" (searchSubmit)="onHospitalSearch($event)"
					(scrolled)="onScrollHospital($event)">
					<app-option [value]="null">{{ "status.all" | translate }}</app-option>
					<app-option *ngFor="let h of hospitals" [value]="h?._id">
						{{ h | translateObject : lang : "name_kh" : "name_en" }}
					</app-option>
				</app-select>
			</div>

			<!-- Delivery Date (if MATERNITY) -->
			<div class="m-form col-md-12 col-12 form-group mb-3" *ngIf="isMaternity">
				<label>{{ "menu.care_ben.give_birth_date" | translate }}</label>
				<app-date-picker-locale formControlName="delivery_date"></app-date-picker-locale>
			</div>

			<!-- Dead Date (if FUNERAL) -->
			<div class="m-form col-md-12 col-12 form-group mb-3" *ngIf="isFuneral">
				<label>{{ "menu.funeral.dead_date" | translate }}</label>
				<app-date-picker-locale formControlName="dead_date"></app-date-picker-locale>
			</div>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
	<button mat-stroked-button class="m-button-outlined s-sm mr-2" type="button" (click)="onCancel()">
		{{ "button.cancel" | translate }}
	</button>
	<button mat-flat-button class="m-button-primary s-sm" type="button" (click)="onSave()" [disabled]="form.invalid">
		{{ "button.save" | translate }}
	</button>
</mat-dialog-actions>